let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5AKIL")).then(() => parcelRequire('i8Vfe'));